const versions = {
    ui: 'bd65a2e2e3835682ef01e989bbb51598c7fd29f1'
};

export default versions;
